<template>
   <div class="section section-flats" id="section-flats" v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }">
        <div class="container">
            <div class="flats-top-content">
                <div class="col-left">
                    <div class="section-title-page section-title-page-white">
                        <h4>{{flats.section}}</h4>
                        <h2>{{flats.title}}</h2>
                    </div>
                    <div class="number-of-section number-of-section-white">
                        <span>07</span>
                    </div>
                    <div class="desc">
                        <p v-html="flats.desc"></p>
                    </div>
                    <div class="desc-content">
                        <p v-html="flats.content_desc"></p>
                    </div>
                </div>
                <div class="col-right">
                    <div class="flats-img">
                        <img :src="flats.img" alt="">
                    </div>
                </div>
            </div>
            <!-- <Cards></Cards> -->
            <CRMflats id="flats-crm-plans"></CRMflats>
        </div>
   </div>
</template>

<script>
    import CRMflats from '@/components/flats-crm/flats-crm-section.vue'
    import {mapGetters} from 'vuex'
    // import Cards from '@/components/flats/cards.vue';
    export default {
        name: 'Flats',
        components: {
            CRMflats,
            // Cards
        },
        data () {
            return {
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.15,0.55]
                }
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            flats: 'loadFlatsPage',
        }),
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('active');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/flats/flats.scss';
    @import '@/styles/components/flats/flats-respond/flats-respond.scss';
	// @import '@/styles/components/animation/animation-flat.scss';
</style>